<template>
	<div class="menu">
		<div v-for='(item,index) in TABACTIVE.item' :key='index'>
			<p class="menu-title">{{item.name}}</p>
			<div class="menu-list">
				<div v-for='(child,jndex) in item.childList' 
				 :key='jndex' class="menu-item"
				 @click='choose(item,child)'
				>{{child.name}}</div>
			</div>
		</div>
	</div>
</template>

<script scoped>
	import {mapGetters} from 'vuex'
	import pageRouter from "@/utils/pageRouter"

	export default {
		name: 'menuDetail',
		computed: {
		    ...mapGetters('tabs', {
		      TABACTIVE: 'tabActive',
		      TABLIST: 'tabList'
		    })
		},
		methods: {
			choose(item,child) {
				let tab = {
					code: child.code,
			        name: child.name,
			        limit: child.childList,
			        parent: item.code,
			        root: this.TABACTIVE.code
				}
				//改变tab
      			this.$store.dispatch("tabs/switchTab_single", tab)
			}
		}
	};
</script>

<style type="text/less" lang="less" scoped>
	.menu{
		padding: 0 10px;
		font-size: 18px;
	}
	.menu-title{
		color: @main_color_active;
		margin-bottom: 30px;
	}
	.menu-list{
		padding-bottom: 40px;
		border-bottom: 1px dashed #E1E3E5;
	}
	.menu-item{
		display: inline-block;
		padding: 12px 18px;
		border: 1px solid #E8EAEB;
		color: @main_color;
		margin-right: 40px;
		cursor: pointer;
		margin-bottom: 8px;
		&:hover{
			background: #F3F8FF;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/menu.vue